import React, { useState } from "react";
import { API_ENDPOINTS } from "../config/api";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.login, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("auth", "true");
        localStorage.setItem("username", username);
        localStorage.setItem("password", password);
        // store token if returned: localStorage.setItem("token", data.token);
        window.location.reload();
      } else {
        const err = await response.json();
        setError(err.detail || "❌ Invalid credentials");
      }
    } catch (err) {
      setError("❌ Network or server error");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md w-80 space-y-4">
        <h2 className="text-lg font-bold text-center">Welcome Call Agent</h2>
        {error && <div className="text-red-500 text-sm text-center">{error}</div>}
        <input
          type="text"
          placeholder="Username"
          className="w-full p-2 border rounded"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="w-full p-2 border rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="w-full bg-purple-600 text-white p-2 rounded" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;

